const prepareAddress = (address) =>  {
    const {
        addressType,
        address: street,
        number,
        neighborhood,
        city,
        complement,
        longitude,
        latitude
    } = address;

    const parts = [];

    const line1 = [];
    if (addressType) line1.push(addressType);
    if (street) line1.push(number ? `${street}, ${number}` : street);
    if (line1.length) parts.push(line1.join("\n"));

    const line2 = [];
    if (neighborhood) line2.push(neighborhood);
    if (city) line2.push(city);
    if (line2.length) parts.push(line2.join("\n"));

    if (complement) parts.push(complement);

    const coords = [];
    if (longitude) coords.push(longitude);
    if (latitude) coords.push(latitude);
    if (coords.length) parts.push(coords.join("\n"));

    return parts.join("\n");
}

export default prepareAddress;
